import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Right = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Right" {...props}>
    <path d="M8.29302 6.70711C7.90249 6.31658 7.90249 5.68357 8.29302 5.29304C8.68354 4.90252 9.31655 4.90252 9.70708 5.29304L15.7071 11.293C16.0976 11.6836 16.0976 12.3166 15.7071 12.7071L9.70708 18.7071C9.31655 19.0976 8.68354 19.0976 8.29302 18.7071C7.90249 18.3166 7.90249 17.6836 8.29302 17.293L13.586 12.0001L8.29302 6.70711Z" fill="#000" />
  </StyledIcon>
));

Right.displayName = 'Right';

export { Right };
